import api, { requiresAccountId } from "../_app/api";

export type LogicMonitorToken = string;

const LM_TOKEN_KEY = "jwt";

export const getLogicMonitorToken = () => localStorage.getItem(LM_TOKEN_KEY);
export const saveLogicMonitorToken = (token: LogicMonitorToken) => {
  if (token) localStorage.setItem(LM_TOKEN_KEY, token);
};
export const deleteLogicMonitorToken = () => localStorage.removeItem(LM_TOKEN_KEY);

export const fetchLogicMonitorToken = async (accountId: string = "") => {
  requiresAccountId(accountId);
  const { data }: { data: LogicMonitorToken } = await api({
    method: "GET",
    url: `/logic-monitor/${accountId}/jwt`,
  });
  return data;
};
